import { updateIsAllDayEventExplicitlySet } from 'owa-calendar-compose-form-actions';
import { getComposeViewState } from 'owa-calendar-compose-store-manager';
import { mutator } from 'satcheljs';

export default mutator(updateIsAllDayEventExplicitlySet, actionMessage => {
    const composeViewState = getComposeViewState(actionMessage.formId);
    composeViewState.isAllDayEventExplicitlySet = true;
});
